import '../../App.css'
import React, { useContext } from "react";
import { TbBuilding, TbHome, TbUsersGroup, TbDeviceDesktop, TbHexagons, TbUserStar, TbUserCog, TbLayoutBoardSplit, TbDeviceDesktopCog, TbDatabaseCog } from "react-icons/tb";
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { slide as Slider } from 'react-burger-menu';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from "../../context/AuthContext";
import Cookies from 'js-cookie'
import { ApiContext } from '../../context/ApiContext';
import { StyleContext } from '../../context/StyleContext';

function MenuLateral() {

    const { logoMenu, corSecundaria, isMenuOpen, toggleMenu } = useContext(StyleContext)
    const location = useLocation();
    const isExact = (path) => location.pathname === path;

    const startsWithAny = (paths) =>
        paths.some(path => location.pathname.startsWith(path));

    const empresa = process.env.REACT_APP_EMPRESA;

    let logo
    if (empresa === "COAMO") {
        logo = require('../../images/logo.png')
    } else {
        logo = require('../../images/smartDemand2.png')
    }

    const { setAuth } = useContext(AuthContext)

    const { FiltroDemanda, setFiltroDemanda, Permissao } = useContext(ApiContext)

    const navigate = useNavigate()

    const role = Cookies.get('Role')

    const navigateDemanda = () => {
        setFiltroDemanda({
            ...FiltroDemanda,
            linhaAtendimentoId: 0,
            setorGerenciaDemandaId: 0,
            cicloId: 0,
            somenteAtrasadas: false,
            guT_BSC_Pontuacao_Inicial: 0,
            guT_BSC_Pontuacao_Final: 0,
            faseId: 0,
            numero: 0,
            somenteSemCiclo: false,
            faseDemanda: '',
            somenteCanceladas: false,
            somenteConcluidas: false
        });
        navigate("/demanda")
    }

    const sair = () => {
        Cookies.remove("Token")
        Cookies.remove("Key")
        setAuth(false);
        navigate('/');
    }

    return (
        <>
            <button
                onClick={toggleMenu}
                style={{
                    position: 'fixed',
                    top: '20px',
                    left: '20px',
                    zIndex: 3,
                    background: 'none',
                    border: 'none',
                    fontSize: '28px',
                    cursor: 'pointer',
                    color: '#fff'
                }}
            >
                ☰
            </button>
            <Sidebar
                className="sidebar-custom-scroll"
                style={{
                    height: "100vh",
                    position: "fixed",
                    top: 0,
                    left: 0,
                    overflowY: "scroll",
                    padding: isMenuOpen ? "80px 10px 0 10px" : "0px",
                    width: isMenuOpen ? "300px" : "0px",
                    minWidth: isMenuOpen ? "300px" : "0px",
                    maxWidth: isMenuOpen ? "300px" : "0px",
                    fontSize: "13px",
                    "--menu-active-bg": corSecundaria,
                    transition: "width 0.3s ease-in-out",
                }}>
                <Menu>
                    <MenuItem
                        component={<Link to="/dashboard" />}
                        icon={<TbHome style={{ color: corSecundaria }} />}
                        active={isExact("/dashboard")}
                    >
                        Dashboard
                    </MenuItem>
                    <SubMenu label="Portfólios" icon={<TbLayoutBoardSplit style={{ color: corSecundaria }} />} active={startsWithAny([
                        "/ciclo", "/bsc", "/swot", "/swotservicos", "/swotTI",
                        "/areas", "/capacidadenegocio", "/fornecedor", "/dominiomapacalor",
                        "/aplicacao", "/matriztime",
                        "/servicos", "/grupo", "/subgrupo", "/item", "/sla", "/periodicidade",
                        "/tiposervico", "/metodosolicitacao", "/cobertura", "/praticareferencia",
                        "/organizacao", "/localidade",
                        "/demanda", "/priorizacaodemandas",
                        "/categorizacaoestrategica", "/tipo", "/avaliacao", "/planonegocios",
                        "/competencia", "/cargo", "/pessoa", "/linhaatendimento"
                    ])} defaultOpen={startsWithAny([
                        "/ciclo", "/bsc", "/swot", "/swotservicos", "/swotTI",
                        "/areas", "/capacidadenegocio", "/fornecedor", "/dominiomapacalor",
                        "/aplicacao", "/matriztime",
                        "/servicos", "/grupo", "/subgrupo", "/item", "/sla",
                        "/periodicidade", "/tiposervico", "/metodosolicitacao",
                        "/cobertura", "/praticareferencia", "/organizacao", "/localidade",
                        "/demanda", "/priorizacaodemandas",
                        "/categorizacaoestrategica", "/tipo", "/avaliacao", "/planonegocios",
                        "/competencia", "/cargo", "/pessoa", "/linhaatendimento"
                    ])}>
                        <SubMenu className='submenu-active' icon={<TbBuilding style={{ color: corSecundaria }} />} label="Estratégico" active={startsWithAny([
                            "/ciclo", "/bsc", "/swot", "/swotservicos", "/swotTI"
                        ])} defaultOpen={startsWithAny([
                            "/ciclo", "/bsc", "/swot", "/swotservicos", "/swotTI"
                        ])}>
                            {!!Permissao.find(item => item.menu.descricao === "CADASTROS" && (item.edicao === true || item.somenteLeitura === true)) && (
                                <MenuItem component={<Link to="/ciclo" />} active={isExact("/ciclo")} className="only-text-active">
                                    Ciclos
                                </MenuItem>
                            )}
                            {!!Permissao.find(item => item.menu.descricao === "BSC" && (item.edicao === true || item.somenteLeitura === true)) && (
                                <MenuItem component={<Link to="/bsc" />} active={isExact("/bsc")} className="only-text-active"> BSC </MenuItem>
                            )}
                            {!!Permissao.find(item => item.menu.descricao === "SWOT" && (item.edicao === true || item.somenteLeitura === true)) && (
                                <MenuItem component={<Link to="/swot" />} active={isExact("/swot")} className="only-text-active"> SWOT</MenuItem>
                            )}
                            {!!Permissao.find(item => item.menu.descricao === "SWOT" && (item.edicao === true || item.somenteLeitura === true)) && (
                                <MenuItem component={<Link to="/swotti" />} active={isExact("/swotti")} className="only-text-active"> SWOT de TI</MenuItem>
                            )}
                            {!!Permissao.find(item => item.menu.descricao === "SWOT SERVICO" && (item.edicao === true || item.somenteLeitura === true)) && (
                                <MenuItem component={<Link to="/swotservicos" />} active={isExact("/swotservicos")} className="only-text-active"> SWOT de Serviços </MenuItem>
                            )}

                        </SubMenu>
                        {!!Permissao.find(item => item.menu.descricao === "CADASTROS" && (item.edicao === true || item.somenteLeitura === true)) && (
                            <SubMenu className='submenu-active' icon={<TbUsersGroup style={{ color: corSecundaria }} />} label="Negócios" active={startsWithAny([
                                "/areas", "/capacidadenegocio", "/fornecedor", "/dominiomapacalor"
                            ])} defaultOpen={startsWithAny([
                                "/areas", "/capacidadenegocio", "/fornecedor", "/dominiomapacalor"
                            ])}>
                                <MenuItem component={<Link to="/areas" />} active={isExact("/areas")} className="only-text-active">Cadeia de Valor / Áreas</MenuItem>
                                <MenuItem component={<Link to="/capacidadenegocio" />} active={isExact("/capacidadenegocio")} className="only-text-active">Capacidades de Negócio</MenuItem>
                                <MenuItem component={<Link to="/fornecedor" />} active={isExact("/fornecedor")} className="only-text-active">Fornecedores</MenuItem>
                                <MenuItem component={<Link to="/dominiomapacalor" />} active={isExact("/dominiomapacalor")} className="only-text-active">Domínio do Mapa de Calor</MenuItem>
                            </SubMenu>
                        )}

                        <SubMenu className='submenu-active' icon={<TbDeviceDesktop style={{ color: corSecundaria }} />} label="Tecnologia" active={startsWithAny(["/aplicacao", "/matriztime"])} defaultOpen={startsWithAny([
                            "/aplicacao", "/matriztime"
                        ])}>
                            {!!Permissao.find(item => item.menu.descricao === "CADASTROS" && (item.edicao === true || item.somenteLeitura === true)) && (
                                <MenuItem component={<Link to="/aplicacao" />} active={isExact("/aplicacao")} className="only-text-active">Aplicações</MenuItem>
                            )}
                            {!!Permissao.find(item => item.menu.descricao === "MATRIZ TIME" && (item.edicao === true || item.somenteLeitura === true)) && (
                                <MenuItem component={<Link to="/matriztime" />} active={isExact("/matriztime")} className="only-text-active">Avaliação</MenuItem>
                            )}
                        </SubMenu>

                        <SubMenu className='submenu-active' icon={<TbUserCog style={{ color: corSecundaria }} />} label="Serviços" active={startsWithAny([
                            "/servicos", "/grupo", "/subgrupo", "/item", "/sla",
                            "/periodicidade", "/tiposervico", "/metodosolicitacao",
                            "/cobertura", "/praticareferencia", "/organizacao", "/localidade"
                        ])} defaultOpen={startsWithAny([
                            "/servicos", "/grupo", "/subgrupo", "/item", "/sla",
                            "/periodicidade", "/tiposervico", "/metodosolicitacao",
                            "/cobertura", "/praticareferencia", "/organizacao", "/localidade"
                        ])}>
                            {!!Permissao.find(item => item.menu.descricao === "SERVICOS" && (item.edicao === true || item.somenteLeitura === true)) && (
                                <MenuItem component={<Link to="/servicos" />} active={isExact("/servicos")} className="only-text-active"> Serviços</MenuItem>
                            )}
                            {!!Permissao.find(item => item.menu.descricao === "CADASTROS" && (item.edicao === true || item.somenteLeitura === true)) && (
                                <SubMenu className='teste-active' label="Cadastros" defaultOpen={startsWithAny([
                                    "/grupo", "/subgrupo", "/item", "/sla",
                                    "/periodicidade", "/tiposervico", "/metodosolicitacao",
                                    "/cobertura", "/praticareferencia", "/organizacao", "/localidade"
                                ])}>
                                    <MenuItem component={<Link to="/grupo" />} active={isExact("/grupo")} className="only-text-active"> Grupo </MenuItem>
                                    <MenuItem component={<Link to="/subgrupo" />} active={isExact("/subgrupo")} className="only-text-active"> Subgrupo </MenuItem>
                                    <MenuItem component={<Link to="/item" />} active={isExact("/item")} className="only-text-active"> Item </MenuItem>
                                    <MenuItem component={<Link to="/sla" />} active={isExact("/sla")} className="only-text-active"> SLA </MenuItem>
                                    <MenuItem component={<Link to="/periodicidade" />} active={isExact("/periodicidade")} className="only-text-active"> Periodicidade </MenuItem>
                                    <MenuItem component={<Link to="/tiposervico" />} active={isExact("/tiposervico")} className="only-text-active"> Tipo de Serviço </MenuItem>
                                    <MenuItem component={<Link to="/metodosolicitacao" />} active={isExact("/metodosolicitacao")} className="only-text-active"> Método de Solicitação </MenuItem>
                                    <MenuItem component={<Link to="/cobertura" />} active={isExact("/cobertura")} className="only-text-active"> Cobertura </MenuItem>
                                    <MenuItem component={<Link to="/praticareferencia" />} active={isExact("/praticareferencia")} className="only-text-active"> Práticas de Referência </MenuItem>
                                    <MenuItem component={<Link to="/organizacao" />} active={isExact("/organizacao")} className="only-text-active"> Organização </MenuItem>
                                    <MenuItem component={<Link to="/localidade" />} active={isExact("/localidade")} className="only-text-active"> Localidade </MenuItem>
                                </SubMenu>
                            )}
                        </SubMenu>

                        {/* <SubMenu icon={<TbDatabase />} label="Dados">
                            
                        </SubMenu> */}

                        <SubMenu className='submenu-active' icon={<TbHexagons style={{ color: corSecundaria }} />} label="Iniciativas" active={startsWithAny([
                            "/demanda", "/priorizacaodemandas",
                            "/categorizacaoestrategica", "/tipo", "/avaliacao", "/planonegocios"
                        ])} defaultOpen={startsWithAny([
                            "/demanda", "/priorizacaodemandas",
                            "/categorizacaoestrategica", "/tipo", "/avaliacao", "/planonegocios"
                        ])}>
                            {!!Permissao.find(item => item.menu.descricao === "DEMANDAS" && (item.edicao === true || item.somenteLeitura === true)) && (
                                <MenuItem component={<a onClick={() => navigateDemanda()} />} active={isExact("/demanda")} className="only-text-active">Execução</MenuItem>
                            )}
                            {!!Permissao.find(item => item.menu.descricao === "DEMANDAS" && (item.edicao === true || item.somenteLeitura === true)) && (
                                <MenuItem component={<Link to="/priorizacaodemandas" />} active={isExact("/priorizacaodemandas")} className="only-text-active"> Priorização</MenuItem>
                            )}
                            {!!Permissao.find(item => item.menu.descricao === "CADASTROS" && (item.edicao === true || item.somenteLeitura === true)) && (
                                <SubMenu label="Cadastros">
                                    <MenuItem component={<Link to="/categorizacaoestrategica" />} active={isExact("/categorizacaoestrategica")} className="only-text-active"> Categorização Estratégica </MenuItem>
                                    <MenuItem component={<Link to="/tipo" />} active={isExact("/tipo")} className="only-text-active">Tipos de Iniciativa</MenuItem>
                                    <MenuItem component={<Link to="/avaliacao" />} active={isExact("/avaliacao")} className="only-text-active"> Avaliação no Plano</MenuItem>
                                    <MenuItem component={<Link to="/planonegocios" />} active={isExact("/planonegocios")} className="only-text-active"> Plano de Negócios </MenuItem>
                                </SubMenu>
                            )}
                        </SubMenu>

                        {!!Permissao.find(item => item.menu.descricao === "CADASTROS" && (item.edicao === true || item.somenteLeitura === true)) && (
                            <SubMenu className='submenu-active' icon={<TbUserStar style={{ color: corSecundaria }} />} label="Capital Intelectual" active={startsWithAny([
                                "/competencia", "/cargo", "/pessoa", "/linhaatendimento"
                            ])} defaultOpen={startsWithAny([
                                "/competencia", "/cargo", "/pessoa", "/linhaatendimento"
                            ])}>
                                <MenuItem component={<Link to="/competencia" />} active={isExact("/competencia")} className="only-text-active"> Competências </MenuItem>
                                <MenuItem component={<Link to="/cargo" />} active={isExact("/cargo")} className="only-text-active"> Cargos </MenuItem>
                                <MenuItem component={<Link to="/pessoa" />} active={isExact("/pessoa")} className="only-text-active"> Pessoas </MenuItem>
                                <MenuItem component={<Link to="/linhaatendimento" />} active={isExact("/linhaatendimento")} className="only-text-active"> Times </MenuItem>
                            </SubMenu>
                        )}
                    </SubMenu>
                    <MenuItem
                        component={<Link to="/gestaodados" />}
                        icon={<TbDatabaseCog  style={{ color: corSecundaria }} />}
                        active={isExact("/gestaodados")}
                    >
                        Gestão de Dados
                    </MenuItem>
                    {role == "admin" &&
                        <MenuItem icon={<TbDeviceDesktopCog style={{ color: corSecundaria }} />} component={<Link to="/cadastrousuario" />} active={isExact("/cadastrousuario")}>
                            Usuários
                        </MenuItem>
                    }
                </Menu>
            </Sidebar >
        </>
    )
}

export default MenuLateral